export const sortOrders = {
  '-1': 'desc',
  '1':  'asc'
};
